import { MenuItem } from '@app/models/menu';

export const APP_MENU: MenuItem[] = [
  {
    label: 'Proveedores',
    roles: ['admin'],
    children: [
      {
        label: 'Crear',
        route: '/proveedores/crear',
        roles: ['admin'],
      },
      {
        label: 'Ver todos',
        roles: ['admin'],
      },
    ],
  },
  {
    label: 'Calentadores',
    roles: ['admin', 'auditor'],
    children: [
      {
        label: 'Pendientes de auditoría',
        route: '/calentadores/auditoria-pendiente',
        roles: ['auditor'],
      },
    ],
  },
];
